import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { isMobile, isTablet } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import { gsap, Power1, Back } from 'gsap';
import ThreeCanvas from '../components/Webgl/ThreeCanvas';
import AppContext from '../contexts/AppContext';
import EditLayer from '../components/UI/EditLayer';
import { SceneProvider } from '../contexts/SceneContext';
import HomeLayer from '../components/UI/HomeLayer';
import HomeLayerMobile from '../components/UI/HomeLayerMobile';
import BottomNav from '../components/UI/nav/BottomNav';
import TopNav from '../components/UI/nav/TopNav';
import IntroLayer from '../components/UI/introduction/IntroLayer';
import ModalShare from '../components/UI/modals/ModalShare';
import ModalTutorial from '../components/UI/modals/ModalTutorial';
import ConfirmQuitModal from '../components/UI/modals/ConfirmQuitModal';
import { setSearchParam, getUrlVars } from '../utils/URLUtils';
import PanoLoader from '../utils/PanoLoader';
import UndoFocusLayer from '../components/UI/UndoFocusLayer';
import PreviewModeLayer from '../components/UI/PreviewModeLayer';
import selectedJson from '../data/selected.json';
import ArtworksList from '../components/UI/ArtworksList';
import Tips from '../components/UI/Tips';
import './Scene.css';

class Scene extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {};

    this.handleWindowResize = this.handleWindowResize.bind(this);

    this.state.isLoadingTiles = false; // ony for tiles
    this.state.isAppLoaded = false;
    this.state.isAppReady = false;
    this.state.isAppGoneInView = false;
    this.state.isAppAxlStarted = false;

    this.state.showCanvas = true;

    this.state.inhome = false;
    this.state.inview = false;

    this.state.google = null;
    this.state.map = null;
    this.state.panorama = null;
    this.state.location = { lat: 27.17127097241562, lng: 78.04212607816748 };
    this.state.pano = 'JeKwUFYAMWXNWPh3IOg3jw';
    this.state.currentLocation = null;
    this.state.selectedItem = null;
    this.state.selectedObject = null;

    // ------ ux

    this.state.showBottomUx = false;
    this.state.showDownloadJson =
      this.props.params && this.props.params.dljson === true;
    this.state.showLoader = true;
    this.state.showUndo = false;
    this.state.showBackFocus = false;
    this.state.showIntro = true;
    this.state.showPreviewModeLayer = false;
    this.state.showTips = false;
    this.state.showArtworksList = false;
    this.state.showTopUxPreview = false;
    this.state.showTopUxShare = false;
    this.state.showEditArtworks = false;

    this.state.shareModalOpen = false;
    this.state.tutorialModalOpen = false;
    this.state.confirmModalOpen = false;

    this.state.expanded = false;
    this.state.addArtworkEnabled = true;
    this.state.sharingEnabled = false;

    this.state.loadedGallery = null;
    this.state.loadedArtworks = null;
    this.galleryToLoad = null; // will load this in scene after tiles loaded

    this.webGLCanvas = null;

    this.scale =
      this.urlVars && this.urlVars.scale
        ? this.urlVars.scale
        : isMobile
        ? 1.0
        : 1.0;

    this.webGLCanvas = new ThreeCanvas(true);
    this.panoLoader = new PanoLoader();

    // data
    this.state.gacImagesJson = null;
    this.state.gacImagesCategories = null;
    this.state.locationsJson = null;

    this.state.startEditing = !!(this.urlVars && this.urlVars.edit);
    this.state.showBottomUxDelete = true;
    this.state.gyroEnabled = false;

    this.hasOpenedTutorial = false;
    this.hasUserStarted = false;

    this.history = [];
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    this.webGLCanvas.stop();
    this.webGLCanvas.destroyContext();
  }

  // ------------------------------------------------------------------------
  init() {
    // setup webgl scene and sent to context
    const ctx = this.context;

    // axl start
    if (ctx.axl) {
      const AxL = require('../utils/Axl').default;
      ctx.axl.registerMessageCallback(AxL.HostToChild.RESUME, () => {
        this.setState({ isAppAxlStarted: true });
        if (this.webGLCanvas.isFocus) {
          this.webGLCanvas.drawManager.imageManager.unfocusImage();
        }
      });
    } else {
      this.setState({ isAppAxlStarted: true });
    }

    this.setupScene(ctx);
    this.context.three = this.webGLCanvas;

    this.loadAssets();

    let id = null;
    if (this.context.axl && this.props.params) {
      id = this.props.params.id;
    } else {
      const vars = getUrlVars();
      id = vars.id;
    }

    this.pushHistory('home');

    if (!id) {
      this.loadDefaultGallery();
    } else {
      // is is a new
      console.log(id);
      ctx.dbManager.get(
        id,
        (result) => {
          if (result && result.data) {
            let editMode = false;

            this.webGLCanvas.autoRotate = true;
            this.webGLCanvas.drawManager.enableMouse = editMode;

            let state = {
              showIntro: true,
              loadedGallery: result,
              location: result.location,
              pano: result.pano,
              inhome: false,
              inview: true,
              startEditing: editMode,
              showTopUxPreview: editMode,
              isAppGoneInView: false,
              addArtworkEnabled: true,
            };

            this.setState(state, () => {
              this.loadTiles();
            });
            this.galleryToLoad = result;
          } else {
            this.loadDefaultGallery();
          }
        },
        () => {
          this.loadDefaultGallery();
        },
      );
    }

    window.addEventListener('resize', this.handleWindowResize, false);

    const mql = window.matchMedia('(orientation: portrait)');
    mql.addListener(function (m) {
      if (this.webGLCanvas && this.webGLCanvas.isFocus) {
        this.webGLCanvas.drawManager.imageManager.unfocusImage();
      }
    });

    window.addEventListener('orientationchange', (event) => {
      if (this.webGLCanvas && this.webGLCanvas.isFocus) {
        this.webGLCanvas.drawManager.imageManager.unfocusImage();
      }
    });
  }

  loadAssets() {
    const db = this.context;
    db.dsManager.loadCsvList(() => {
      this.setState(
        {
          gacImagesJson: db.dsManager.data,
          gacImagesCategories: db.dsManager.categories,
        },
        this.launchApp(),
      );
    });

    db.locManager.loadCsv(() => {
      this.setState(
        {
          locationsJson: db.locManager.data,
        },
        () => {
          this.launchApp();
        },
      );
    });
  }

  loadDefaultGallery() {
    let selected = selectedJson[0];

    if (this.props.params && this.props.params.defaultId) {
      let results = selectedJson.filter((entry) => {
        return entry.id === this.props.params.defaultId;
      });

      if (results.length) {
        selected = results[0];
      }
    }

    const url = 'street-gallery/assets/curated/' + selected.id + '.json';
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.default = true;
        data.meta = selected;
        this.galleryToLoad = data;
        this.setState(
          {
            loadedGallery: data,
            location: data.location,
            pano: data.pano,
            showIntro: true,
            addArtworkEnabled: true,
          },
          () => {
            this.loadTiles();
            this.setCurrentLocationFromPano();
          },
        );

        setSearchParam('id', null);
      });
  }

  createNewPanorama() {
    setSearchParam('id', null);

    this.webGLCanvas.drawManager.reset();
    this.webGLCanvas.drawManager.enableMouse = true;
    this.webGLCanvas.autoRotate = false;
    this.setCurrentLocationFromPano();
    this.setState({
      showTopUxPreview: true,
      showTopUxShare: true,
      loadedGallery: null,
    });

    if (this.state.isAppLoaded) {
      this.setState({
        tutorialModalOpen: true,
      });

      this.hasOpenedTutorial = true;
    }
  }

  launchApp() {
    if (this.isAppReady()) {
      this.setState({
        isAppReady: true,
        showLoader: false,
      });
    }

    if (this.isAppStarted() && !this.state.isAppLoaded) {
      this.startIntroductionZoom();
      this.sendTrackEvent('app-launch');
    }
  }

  startIntroDescription() {
    this.hasUserStarted = true;
    this.launchApp();
  }

  startIntroductionZoom() {
    const delay = 0.25;
    this.webGLCanvas.zoomToCenter(0, 2, delay, () => {
      // this.webGLCanvas.showPlanes();
      if (this.galleryToLoad) {
        this.loadGalleryData(this.galleryToLoad, true);
        this.galleryToLoad = null;
      }

      this.setState(
        {
          showTips:
            !this.state.isAppLoaded &&
            this.state.loadedGallery &&
            this.state.loadedGallery.default &&
            this.state.loadedGallery.meta.featured,
          isAppLoaded: true,
          expanded: true,
        },
        () => {
          this.showDescriptionPopUp();
        },
      );
    });
  }

  showDescriptionPopUp() {
    if (document.querySelector('.container-drag-text') === null) {
      //console.log('skip showDescriptionPopUp tween');
      return this.hideDescriptionPopUp();
    }
    gsap.to(['.container-drag-text'], {
      opacity: 1,
      scaleX: 1,
      scaleY: 1,
      duration: 0.5,
      ease: Back.easeInOut,
      onComplete: () => {
        this.hideDescriptionPopUp();
      },
    });
  }

  hideDescriptionPopUp(delay = 10) {
    if (document.querySelector('.container-drag-text') === null) {
      return this.setState({ showTips: false });
    }
    gsap.to(['.container-drag-text'], {
      opacity: 0,
      delay: delay,
      duration: 0.25,
      ease: Power1.easeInOut,
      onComplete: () => {
        this.setState({ showTips: false });
      },
    });
  }

  start() {
    this.setState({ inhome: true });
    this.hasUserStarted = true;
    this.startIntroductionZoom();

    // this
    if (this.props.params && this.props.params.allowEdit) {
      this.setEditView();
      this.setState(
        {
          inhome: false,
          inview: true,
          startEditing: true,
          showTopUxPreview: true,
          showTopUxShare: true,
          isAppGoneInView: true,
          //addArtworkEnabled: false,
          showUndo: false,
          addArtworkEnabled: true,
          sharingEnabled: true,
        },
        () => {
          this.webGLCanvas.drawManager.enableMouse = true;
        },
      );
    }
  }

  pushHistory(handle) {
    const last = this.history[this.history.length - 1];
    const val = '/' + handle;
    if (val !== last) this.history.push('/' + handle);

    //this.props.location.hash = '#handle';
  }

  sendTrackEvent(action, label, value) {
    if (this.context.axl) {
      const AxL = require('../utils/Axl').default;
      this.context.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action,
        label,
        value,
      });
    }
  }

  onDownloadButtonHandler() {
    const { currentLocation, pano } = this.state;
    const filename = 'gallery.json';
    const { data, camParams } = this.webGLCanvas.getGalleryState();

    const fullData = JSON.stringify(
      {
        active: false,
        location: currentLocation,
        pano,
        data,
        camParams,
      },
      undefined,
      4,
    );

    const blob = new Blob([fullData], { type: 'text/json' });
    const e = document.createEvent('MouseEvents');
    const a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
    e.initMouseEvent(
      'click',
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null,
    );
    a.dispatchEvent(e);
  }

  onShareButtonHandler() {
    if (
      this.context.axl &&
      this.state.loadedGallery &&
      this.state.loadedGallery.default
    ) {
      const AxL = require('../utils/Axl').default;
      this.context.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
        defaultId: this.state.loadedGallery.meta.id,
      });

      this.sendTrackEvent('sharing-inspire', this.state.loadedGallery.meta.id);

      const sharePrevText = this.context.dictionnary.get('share-prev-inspire');
      const shareEndText = this.context.dictionnary.get('share-end');

      const shareTxt =
        sharePrevText +
        this.state.currentLocation.city +
        ', ' +
        this.state.currentLocation.name +
        '. ' +
        shareEndText;
      this.context.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: shareTxt,
      });
      return;
    }

    this.setState({
      showLoader: true,
    });

    //this.sendTrackEvent('sharing-gallery');

    const db = this.context.dbManager;
    const state = this.webGLCanvas.getGalleryState();
    db.save(
      state.data,
      state.camParams,
      this.state.pano,
      this.state.currentLocation,
      (id) => {
        if (!isMobile && !isTablet) {
          this.togglePreviewMode();
          this.onGallerySaved(id);
          this.sendTrackEvent('sharing-gallery', id);
        }
      },
    );
  }

  onGallerySaved(id) {
    if (this.context.axl) {
      const AxL = require('../utils/Axl').default;

      this.context.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, { id: id });

      const sharePrevText = this.context.dictionnary.get('share-prev');
      const shareEndText = this.context.dictionnary.get('share-end');

      const shareTxt =
        sharePrevText +
        this.state.currentLocation.city +
        ', ' +
        this.state.currentLocation.name +
        '. ' +
        shareEndText;

      this.context.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: shareTxt,
      });
      this.setState({
        showLoader: false,
      });
    } else {
      setSearchParam('id', id);
      this.setState({
        shareModalOpen: true,
        currentUrl: window.location.href,
        showLoader: false,
      });
    }
  }

  isAppReady() {
    this.setCurrentLocationFromPano();

    return (
      !this.state.isLoadingTiles &&
      this.state.gacImagesJson &&
      this.state.locationsJson
    );
  }

  isAppStarted() {
    return (
      !this.state.isLoadingTiles &&
      this.state.gacImagesJson &&
      this.state.locationsJson &&
      //this.colorsLoaded &&
      this.hasUserStarted
    );
  }

  setCurrentLocationFromPano() {
    const ctx = this.context;
    const currentLocation = ctx.locManager.getByPanoId(this.state.pano);
    if (currentLocation) {
      this.setState({
        currentLocation,
      });
    }
  }

  //------------------------------------------------------

  loadTiles() {
    const { pano, loadedGallery } = this.state;

    if (!pano) return;

    this.setState({
      showLoader: true,
      isLoadingTiles: true,
    });

    this.panoLoader.getMetadata(pano, (data) => {
      this.panoLoader.loadPanorama(pano);
      this.webGLCanvas.addPanoSphere();

      this.webGLCanvas.setUrlAsTexture(this.panoLoader.getUrl(pano), () => {
        const hasParams = loadedGallery && loadedGallery.camParams;

        if (hasParams) {
          this.webGLCanvas.defaultHeading = loadedGallery.camParams.lon;
          this.webGLCanvas.defaultPitch = loadedGallery.camParams.lat;
        } else {
          this.webGLCanvas.defaultHeading = this.loadedPano.heading - 180; // 90 + this.loadedPano.heading;
          this.webGLCanvas.defaultPitch = -this.loadedPano.pitch;
        }
        this.onLoadTilesComplete();

        const needTilt = true;

        if (needTilt && data) {
          this.webGLCanvas.orientHeading(
            data.Orientation.heading,
            data.Orientation.pitch,
            data.Orientation.roll,
          );

          /*
            this.webGLCanvas.orient(
              data.Projection.pano_yaw_deg,
              data.Projection.tilt_yaw_deg,
              data.Projection.tilt_pitch_deg,
            );
            */
        } else {
          this.webGLCanvas.orientHeading(180 * (Math.PI / 180), 0, 0);
          //console.log('not tilted!');
        }
      });
    });
    this.setCurrentLocationFromPano();
  }

  onLoadTilesComplete() {
    this.setState({
      showLoader: false,
      isLoadingTiles: false,
    });

    // in introduction no need to zoom

    if (this.isAppStarted()) {
      this.webGLCanvas.zoomToCenter(0, 2, 2, () => {
        //this.webGLCanvas.showPlanes();
        if (this.galleryToLoad) {
          this.loadGalleryData(this.galleryToLoad, true);
          this.galleryToLoad = null;
        }
        this.setState({ isAppLoaded: true });
      });

      if (this.hasOpenedTutorial && !this.state.loadedGallery) {
        this.setState({
          showEditArtworks: true,
        });
      }
    } else {
      // try to unlock app
      this.launchApp();
    }
  }

  loadGalleryData(gallery, showOnLoad = false) {
    // load
    this.webGLCanvas.drawManager.load(gallery, showOnLoad);
    this.loadArtworkList();
  }

  loadArtworkList() {
    // get list of artworks
    const list = this.webGLCanvas.drawManager.imageManager.getPlanesIdList();
    const db = this.context;
    const loadedArtworks = db.dsManager.getItemsByIds(list);
    this.setState({
      loadedArtworks,
    });
  }

  //------------------------------------------------------

  setupScene(ctx) {
    this.webGLCanvas.db = ctx.dbManager;
    this.webGLCanvas.setupScene(this.container);

    const datasetManager = this.context.dsManager;

    this.webGLCanvas.on('mousedown', (result) => {
      if (this.state.showTips) {
        this.hideDescriptionPopUp(0);
      }
      // only in edition mode
      if (this.webGLCanvas.drawManager.enableMouse) {
        // to get the item palette

        let selectedItem = null;
        let selectedObject = null;

        if (this.webGLCanvas.hasClickedObject) {
          selectedObject =
            this.webGLCanvas.drawManager.imageManager.selectedImage ||
            this.webGLCanvas.drawManager.imageManager.selectedAnchor.parent;

          if (selectedObject) {
            const selectedID = selectedObject.userData.itemId;
            selectedItem = datasetManager.getItemById(selectedID);
          }
        }

        this.setState({
          showBottomUx: this.webGLCanvas.hasClickedObject,
          selectedItem,
          selectedObject,
        });
      }

      // );
    });

    this.webGLCanvas.on('mousemove', (result) => {
      const toolTip = document.getElementsByClassName('container-click-text');
      if (toolTip[0] && !this.webGLCanvas.isFocus) {
        if (result.objectOver) {
          toolTip[0].style.opacity = 1;
          toolTip[0].style.bottom = `${
            -65 + window.innerHeight - result.posInTexture.screenMouseY
          }px`;
          toolTip[0].style.left = `${10 + result.posInTexture.screenMouseX}px`;
        } else {
          toolTip[0].style.opacity = 0;
        }
      }
    });

    this.webGLCanvas.on('mouseleave', (result) => {
      const toolTip = document.getElementsByClassName('container-click-text');
      if (toolTip[0]) {
        toolTip[0].style.opacity = 0;
      }
    });

    this.webGLCanvas.on('focus', (result) => {
      const selectedID = result.userData.itemId;
      const selectedItem = datasetManager.getItemById(selectedID);

      this.setState({
        showBottomUx: true,
        showBottomUxDelete: false,
        selectedItem,
        showBackFocus: true,
        showTips: false,
        showArtworksList: false,
        homeLayerMode: null,
      });

      const toolTip = document.getElementsByClassName('container-click-text');
      if (toolTip[0]) {
        toolTip[0].style.opacity = 0;
      }
      this.pushHistory('focus');
      this.sendTrackEvent('focus-artwork', selectedID);
    });

    this.webGLCanvas.on('focus-end', () => {
      this.sendTrackEvent('unfocus-artwork');

      this.setState({
        showBottomUx: false,
        showBottomUxDelete: true,
        selectedItem: null,
        selectedObject: null,
        showBackFocus: false,
        homeLayerMode: null,
      });
    });

    this.webGLCanvas.on('orientation', (enabled) => {
      this.setState({
        gyroEnabled: this.webGLCanvas.orientationIsEnabled,
      });
    });

    this.webGLCanvas.drawManager.on('push-history', (data) => {
      this.setState({
        showUndo: data.nPlanes > 0,
        addArtworkEnabled: data.nPlanes < 30,
        sharingEnabled: data.nPlanes > 0,
      });
    });
    this.webGLCanvas.drawManager.on('clear-history', () => {
      this.setState({
        showUndo: false,
        sharingEnabled: false,
      });
    });
  }

  // ------------------------------------------------------  UI events

  onOpacityHandler(val) {
    this.webGLCanvas.drawManager.imageManager.setOpacity(val);
  }

  onDeleteIconHandler(val) {
    if (this.webGLCanvas.drawManager.imageManager.deleteSelected()) {
      this.webGLCanvas.drawManager.pushHistory();
      this.webGLCanvas.hasClickedObject = false;
      this.setState({
        showBottomUx: this.webGLCanvas.hasClickedObject,
        selectedItem: null,
        selectedObject: null,
      });
    }
  }

  // ------------------------------------------------------  listeners

  resetCommonStates() {
    this.setState({
      showBottomUx: false,
      shareModalOpen: false,
      showPreviewModeLayer: false,
      showArtworksList: false,
      showTips: false,
    });
  }

  undo() {
    this.webGLCanvas.drawManager.undo();
  }

  toggleArtworksList() {
    if (!this.state.showArtworksList) this.loadArtworkList();
    this.setState({
      showArtworksList: !this.state.showArtworksList,
    });
  }

  togglePreviewMode() {
    if (this.state.inview) {
      this.loadArtworkList();
      this.webGLCanvas.drawManager.enableMouse = false;
      this.webGLCanvas.drawManager.imageManager.clearSelected();

      this.setState({
        inview: false,
        showBottomUxDelete: false,
        showBottomUx: false,
        showPreviewModeLayer: true,
      });
    } else {
      this.webGLCanvas.drawManager.enableMouse = true;
      this.webGLCanvas.drawManager.imageManager.unfocusImage();

      this.setState({
        inview: true,
        showArtworksList: false,
        showBottomUxDelete: true,
        showPreviewModeLayer: false,
        showTips: false,
        startEditing: !this.state.loadedGallery,
      });
    }
  }

  setHomeView(updateHistory = true) {
    if (updateHistory) this.pushHistory('home');
    this.webGLCanvas.drawManager.imageManager.clearSelected();
    this.webGLCanvas.drawManager.imageManager.unfocusImage();

    const hasLoadedGallery = this.state.loadedGallery;
    this.webGLCanvas.drawManager.enableMouse = !hasLoadedGallery;

    this.resetCommonStates();
    this.setState({
      inview: false,
      inhome: true,
      showTopUX: !hasLoadedGallery,
      showTopUxPreview: !hasLoadedGallery,
      showBottomUxDelete: !hasLoadedGallery,
      startEditing: hasLoadedGallery,
      homeLayerMode: null,
    });
  }

  setEditView() {
    this.pushHistory('view');

    this.webGLCanvas.drawManager.imageManager.clearSelected();
    const hasLoadedGallery = this.state.loadedGallery;
    this.webGLCanvas.drawManager.enableMouse = !hasLoadedGallery;

    this.resetCommonStates();
    this.setState({
      inhome: false,
      inview: true,
      startEditing: !hasLoadedGallery,
      showTopUxPreview: !hasLoadedGallery,
      showBottomUxDelete: !hasLoadedGallery,
      isAppGoneInView: true,
      showCanvas: true,
    });
  }

  onAboutClickHandler() {
    // we keep last state
    this.sendTrackEvent('view-about');

    this.setHomeView(false);
    this.pushHistory('about');

    this.resetCommonStates();
    this.setState({
      expanded: true,
      homeLayerMode: 'about',
      showCanvas: false,
    });
  }

  onHomeViewStateChange(mode) {
    if (isMobile || isTablet) {
      if (mode === 'inspire-me' || mode === 'about') {
        this.setState({
          showCanvas: false,
        });
      } else {
        this.setState({
          showCanvas: true,
        });
      }
    }
    //this.pushHistory(mode);
    this.resetCommonStates();
    // reset main state
    this.setState({
      homeLayerMode: mode,
      showTips: false,
    });
  }

  checkLeavingStatus(handler) {
    if (!this.state.loadedGallery) {
      this.setState({
        expanded: false,
        confirmModalOpen: true,
      });
      this.onConfirmModalHandler = handler;
    } else {
      handler();
    }
  }

  onInspireMeClickHandler(result) {
    if (isMobile || isTablet) {
      document.body.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    this.sendTrackEvent('view-inspire', result.id);

    setSearchParam('id', null);

    this.loadedPano = result;
    this.webGLCanvas.drawManager.reset();
    this.webGLCanvas.prepareForLoading();
    this.webGLCanvas.autoRotate = false;
    this.webGLCanvas.drawManager.enableMouse = false;
    this.setState({
      expanded: false,
      showCanvas: true,
    });

    fetch('street-gallery/assets/curated/' + result.id + '.json')
      .then((response) => response.json())
      .then((data) => {
        data.default = true;
        data.meta = result;
        data.notTilted = result.isTilted ? false : true;

        this.galleryToLoad = data;

        this.resetCommonStates();
        this.setState(
          {
            loadedGallery: data,
            location: data.location,
            pano: data.pano,
            currentLocation: this.loadedPano,
            inhome: false,
            inview: true,
            showTopUxPreview: false,
            startEditing: false,
            addArtworkEnabled: true,
            expanded: false,
            isAppGoneInView: true,
            showTopUxShare: true,
          },
          () => {
            this.loadTiles();
            this.pushHistory('view');

            //console.log('et on y go');
          },
        );
      });
  }

  onCityClickHandler(result) {
    this.sendTrackEvent('view-location', result.panoid);

    this.loadedPano = result;
    setSearchParam('id', null);
    this.webGLCanvas.drawManager.reset();
    this.galleryToLoad = null;
    this.webGLCanvas.prepareForLoading();
    this.webGLCanvas.drawManager.enableMouse = true;
    this.webGLCanvas.autoRotate = false;
    this.resetCommonStates();
    this.setState(
      {
        inhome: false,
        pano: result.panoid,
        inview: true,
        currentLocation: result,
        startEditing: true,
        showTopUxPreview: true,
        loadedGallery: null,
        expanded: false,
        isAppGoneInView: true,
        showTopUxShare: true,
        showCanvas: true,
      },
      () => {
        this.pushHistory('view');
        this.loadTiles();
      },
    );

    if (this.state.isAppLoaded) {
      this.setState({
        tutorialModalOpen: !this.hasOpenedTutorial,
      });

      this.hasOpenedTutorial = true;
    }
  }

  // TODO clean this
  onArtworkListItemHandler(item) {
    const object = this.webGLCanvas.drawManager.imageManager.getPlaneForAssetId(
      item['asset_id'],
    );

    this.webGLCanvas.useFixedCamTarget = true;
    this.webGLCanvas.cameraTarget.x = object.geometry.boundingSphere.center.x;
    this.webGLCanvas.cameraTarget.y = object.geometry.boundingSphere.center.y;
    this.webGLCanvas.cameraTarget.z = object.geometry.boundingSphere.center.z;
    const latlon = this.webGLCanvas.vector3toLonLat(
      this.webGLCanvas.cameraTarget,
    );
    this.webGLCanvas.useFixedCamTarget = false;
    this.webGLCanvas.lon = latlon[0];
    this.webGLCanvas.lat = latlon[1];
  }

  onHomeBackButtonHandler() {
    //this.setEditView();
    //this.pushHistory('view');

    const prevMode = this.history[this.history.length - 2];

    if (prevMode === '/view') {
      this.setEditView();
    }
    if (prevMode === '/focus') {
      this.setEditView();
      this.webGLCanvas.drawManager.imageManager.unfocusImage();
    }
    if (
      prevMode === '/home' ||
      prevMode === '/create-artwork' ||
      prevMode === '/inspire-me'
    ) {
      this.setHomeView();
    }
  }

  onGyroHandler() {
    this.webGLCanvas.initDeviceOrientation();
  }

  // ------------------------------------------------------  visibility

  isHomeLayerVisible() {
    return !isMobile && this.state.inhome && !this.state.showBottomUx;
  }

  isHomeLayerMobileVisible() {
    return (
      isMobile &&
      this.state.isAppLoaded &&
      (this.state.inhome || (this.state.inview && this.state.loadedGallery)) &&
      !this.state.showBottomUx
    );
  }
  gyroLayerVisible() {
    return false;
  }
  isEditLayerVisible() {
    return (
      this.state.isAppLoaded &&
      this.state.inview &&
      !this.state.inhome &&
      !this.state.showBackFocus
    );
  }

  isTipsVisible() {
    const val =
      this.state.showTips &&
      !this.state.isAppGoneInView &&
      this.state.inhome &&
      this.state.showCanvas &&
      !isMobile &&
      !this.state.homeLayerMode;

    return val;
  }

  handleWindowResize() {
    this.webGLCanvas.handleWindowResize();
  }

  render() {
    const { dictionnary } = this.context;

    return (
      <>
        <SceneProvider value={{ webgl: this.webGLCanvas }}>
          <IntroLayer
            isAppAxlStarted={this.state.isAppAxlStarted}
            isAppReady={this.state.isAppReady}
            loadedGallery={this.state.loadedGallery}
            isSharedDefault={
              this.props.params && this.props.params.defaultId ? true : false
            }
            currentLocation={this.state.currentLocation}
            onClickHandler={() => {
              this.startIntroDescription();
            }}
            onEndIntroHandler={() => {
              if (!this.hasUserStarted) this.start();
            }}
          />

          <TopNav
            showDownloadJson={this.state.showDownloadJson}
            preview={!this.state.showPreviewModeLayer}
            loading={this.state.showLoader}
            sharingEnabled={this.state.sharingEnabled}
            onHomeClickHandler={() => {
              this.setHomeView(true);
            }}
            onSaveAndShare={() => {
              this.onShareButtonHandler();
            }}
            onDownload={() => {
              this.onDownloadButtonHandler();
            }}
            onPreviewBtn={() => {
              this.togglePreviewMode();
            }}
            onAboutClickHandler={() => {
              this.onAboutClickHandler();
            }}
            showPreview={this.state.showTopUxPreview}
            showShare={this.state.showTopUxShare}
          />

          {this.state.showArtworksList && !isMobile && !isTablet && (
            <ArtworksList
              loadedArtworks={this.state.loadedArtworks}
              onArtworkListItemHandler={(item) => {
                this.onArtworkListItemHandler(item);
              }}
              onCloseHandler={() => {
                this.setState({ showArtworksList: false });
              }}
            ></ArtworksList>
          )}

          {this.isHomeLayerVisible() && (
            <HomeLayer
              mode={this.state.homeLayerMode}
              loadedGallery={this.state.loadedGallery}
              currentLocation={this.state.currentLocation}
              locManager={this.context.locManager}
              onStateChange={(mode) => {
                this.onHomeViewStateChange(mode);
              }}
              onLocationClickHandler={(result) => {
                this.checkLeavingStatus(() => {
                  this.onInspireMeClickHandler(result);
                });
                //this.onInspireMeClickHandler(result);
              }}
              onCityClickHandler={(result) => {
                this.checkLeavingStatus(() => {
                  this.onCityClickHandler(result);
                });
              }}
              onBackButtonHandler={() => {
                this.onHomeBackButtonHandler();
              }}
              onToggleArtworks={() => {
                this.toggleArtworksList();
              }}
              showBackButton={this.state.isAppGoneInView}
              backButtonCopy={
                !this.state.loadedGallery
                  ? dictionnary.get('home-back-edit')
                  : dictionnary.get('home-back')
              }
            />
          )}

          {this.isHomeLayerMobileVisible() && (
            <HomeLayerMobile
              expanded={this.state.expanded}
              showList={false}
              locManager={this.context.locManager}
              onHomeExpandHandler={() => {
                this.setState({
                  expanded: !this.state.expanded,
                });
              }}
              onCloseButtonHandler={() => {
                document.body.scrollTop = 0;
                document.scrollingElement.scrollTop = 0;
                document.documentElement.scrollTop = 0;

                if (this.state.isAppGoneInView) {
                  this.setState({
                    inhome: false,
                    inview: true,
                    showCanvas: true,
                  });
                }
              }}
              onBackButtonHandler={() => {
                document.body.scrollTop = 0;
                document.scrollingElement.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.setState({ expanded: false, showCanvas: true });
              }}
              onLocationClickHandler={(result) => {
                this.onInspireMeClickHandler(result);
              }}
              onCityClickHandler={(result) => {
                this.onCityClickHandler(result);
              }}
              onStateChange={(mode) => {
                this.onHomeViewStateChange(mode);
              }}
              onShareHandler={() => this.onShareButtonHandler()}
            />
          )}

          {this.state.showBackFocus && this.state.showBottomUx && (
            <UndoFocusLayer
              onBackButtonHandler={() => {
                this.webGLCanvas.drawManager.imageManager.unfocusImage();
              }}
            />
          )}

          {!this.state.showBackFocus && this.state.showPreviewModeLayer && (
            <PreviewModeLayer
              currentLocation={this.state.currentLocation}
              onToggleArtworks={() => {
                this.toggleArtworksList();
              }}
              onBackButtonHandler={() => {
                this.togglePreviewMode();
              }}
            />
          )}

          <div className="app-container">
            <ModalShare
              onCloseHandler={() => this.setState({ shareModalOpen: false })}
              open={this.state.shareModalOpen}
              currentLocation={this.state.currentLocation}
              currentUrl={this.state.currentUrl}
            />
            {this.isEditLayerVisible() && (
              <>
                <EditLayer
                  openDefault={this.state.showEditArtworks}
                  loadedGallery={this.state.loadedGallery}
                  addArtworkEnabled={this.state.addArtworkEnabled}
                  showUndo={this.state.showUndo}
                  currentLocation={this.state.currentLocation}
                  startEditing={this.state.startEditing}
                  artworksData={this.state.gacImagesJson}
                  categories={this.state.gacImagesCategories}
                  locationData={selectedJson}
                  currentGalleryID={this.state.currentGalleryID}
                  onOpenHandler={() => {
                    this.setState({ showEditArtworks: true });
                  }}
                  onCloseHandler={() => {
                    this.setState({ showEditArtworks: false });
                  }}
                  onArtworksOpenHandler={() => {
                    this.setState({ showBottomUx: false });
                  }}
                  onCreateHandler={() => {
                    this.createNewPanorama();
                  }}
                  // launch buc.js
                  onChangeLocationHandler={(result) => {
                    this.onCityClickHandler(result);
                  }}
                  onShareButtonHandler={() => {
                    this.onShareButtonHandler();
                  }}
                  onBackHomeHandler={() => {
                    this.setHomeView(true);
                  }}
                  onUndoButtonHandler={() => {
                    this.undo();
                  }}
                  onAddPictureFromDisk={(file) => {
                    this.loadPictureFromDisk(file);
                  }}
                  onBackButtonHandler={(handler) => {
                    this.setState({
                      confirmModalOpen: true,
                    });
                    this.onConfirmModalHandler = handler;
                  }}
                  onToggleArtworksList={() => {
                    this.toggleArtworksList();
                  }}
                  locationPosition={this.state.inhome ? 'right' : null}
                />

                {!isMobile && (
                  <>
                    <ModalTutorial
                      open={this.state.tutorialModalOpen}
                      onCloseHandler={() => {
                        this.setState({
                          tutorialModalOpen: false,
                          showEditArtworks: true,
                        });
                      }}
                    />
                  </>
                )}
              </>
            )}
          </div>
          {this.state.confirmModalOpen && (
            <ConfirmQuitModal
              open={this.state.confirmModalOpen}
              onConfirmationHandler={() => {
                this.setState({ confirmModalOpen: false });
                if (this.onConfirmModalHandler) {
                  this.onConfirmModalHandler();
                }
              }}
              onCancelHandler={() => {
                this.setState({ confirmModalOpen: false });
                this.setEditView();
              }}
            />
          )}

          {this.isTipsVisible() && <Tips></Tips>}

          <div
            id="three-canvas"
            style={
              !this.state.showCanvas && (isMobile || isTablet)
                ? { display: 'none' }
                : { display: 'block' }
            }
            ref={(container) => {
              this.container = container;
            }}
          />

          {this.state.showBottomUx && (
            <Grid container className="footer">
              <BottomNav
                showTrash={this.state.showBottomUxDelete}
                selectedItem={this.state.selectedItem}
                selectedObject={this.state.selectedObject}
                onOpacityHandler={(val) => this.onOpacityHandler(val)}
                onDeleteIconHandler={(val) => this.onDeleteIconHandler(val)}
              />
            </Grid>
          )}
        </SceneProvider>
      </>
    );
  }
}

export default withRouter(Scene);
